"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/modal/style/css");

var _modal = _interopRequireDefault(require("antd/es/modal"));

require("antd/es/table/style/css");

var _table = _interopRequireDefault(require("antd/es/table"));

require("antd/es/button/style/css");

var _button = _interopRequireDefault(require("antd/es/button"));

require("antd/es/progress/style/css");

var _progress = _interopRequireDefault(require("antd/es/progress"));

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

require("antd/es/row/style/css");

var _row = _interopRequireDefault(require("antd/es/row"));

require("antd/es/card/style/css");

var _card = _interopRequireDefault(require("antd/es/card"));

require("antd/es/col/style/css");

var _col = _interopRequireDefault(require("antd/es/col"));

var _Column = _interopRequireDefault(require("antd/es/table/Column"));

var _ = _interopRequireWildcard(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _badges = require("../../redux/badges/badges.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _Util = require("../util/Util");

require("./badge.scss");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const rowClassName = (record, index) => {
  return index % 2 === 0 ? 'tr-even-color' : 'tr-odd-color';
};

const initialState = {
  isAwardBadgePopupVisible: false,
  awardBadgeCollectionId: -1,
  participantBadges: []
};

class BadgesTable extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.showAwardBadgeModal = () => {
      this.setState({
        isAwardBadgePopupVisible: true
      });
    };

    this.hideAwardBadgeModal = () => {
      this.setState({
        isAwardBadgePopupVisible: false
      });
    };

    this.awardBadge = () => {
      const {
        participantId,
        awardParticipantBadge
      } = this.props;
      const {
        awardBadgeCollectionId
      } = this.state;
      awardParticipantBadge(participantId, awardBadgeCollectionId);
      this.setState({
        isAwardBadgePopupVisible: false
      });
    };

    this.createBadgeCardGrid = () => {
      const {
        badgeCollections
      } = this.props;
      const {
        isAwardBadgePopupVisible,
        participantBadges,
        awardBadgeCollectionId
      } = this.state;
      const badgeCols = [];

      if (badgeCollections && isAwardBadgePopupVisible) {
        const unearnedBadges = _.filter(badgeCollections, b => {
          const workingOn = _.find(participantBadges, pb => pb.id === b.id);

          return !workingOn || !workingOn.earnedDate;
        });

        unearnedBadges.forEach(badge => {
          const selectedCss = awardBadgeCollectionId === badge.id ? 'selected' : undefined;
          badgeCols.push( /*#__PURE__*/_react.default.createElement(_col.default, {
            key: `col${badge.id.toString()}`,
            span: 4
          }, /*#__PURE__*/_react.default.createElement(_card.default, {
            className: ['badge-card', `${selectedCss ? 'selected' : ''}`].join(' '),
            key: badge.id.toString(),
            bordered: false,
            onClick: e => {
              this.setState({
                awardBadgeCollectionId: badge.id
              });
            }
          }, /*#__PURE__*/_react.default.createElement("img", {
            src: badge.badge
          }), /*#__PURE__*/_react.default.createElement("div", null, badge.label), /*#__PURE__*/_react.default.createElement("div", {
            style: {
              fontSize: 10
            }
          }, badge.description))));
        });
      }

      return /*#__PURE__*/_react.default.createElement(_row.default, {
        className: 'badge-grid-row'
      }, badgeCols);
    };
  }

  componentDidMount() {
    this.props.getBadges();
  }

  renderBadgeProgress(progressCount, badge) {
    if (badge.earnedDate) {
      return (0, _Util.renderPopoverDate)(badge.earnedDate);
    }

    return /*#__PURE__*/_react.default.createElement(_popover.default, {
      content: `${progressCount} of ${badge.quota}`
    }, /*#__PURE__*/_react.default.createElement(_progress.default, {
      style: {
        width: '400px'
      },
      percent: parseFloat((100.0 * (progressCount / badge.quota)).toFixed(0))
    }));
  }

  render() {
    const {
      participantBadges
    } = this.props;
    const {
      isAwardBadgePopupVisible
    } = this.state;
    const badgeGrid = this.createBadgeCardGrid();
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.showAwardBadgeModal
    }, "Award Badge"), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_table.default, {
      dataSource: participantBadges,
      pagination: {
        pageSize: 10
      },
      rowClassName: rowClassName,
      rowKey: "id"
    }, /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: 'ID',
      dataIndex: 'badgeCollectionId',
      key: 'badgeCollectionId',
      width: '70px',
      defaultSortOrder: 'ascend',
      sorter: (a, b) => a.badgeCollectionId - b.badgeCollectionId
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: 'Label',
      dataIndex: 'label',
      key: 'label',
      width: '200px',
      sorter: (a, b) => `${a.label}`.localeCompare(b.label),
      filters: _.map(_.sortedUniq(_.uniq(_.sortBy(_.map(participantBadges, 'label')))), x => {
        return {
          text: x,
          value: x
        };
      }),
      onFilter: (value, record) => record.label === value
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: '600px',
      sorter: (a, b) => `${a.description}`.localeCompare(b.description)
    }), /*#__PURE__*/_react.default.createElement(_Column.default, {
      title: 'Progress',
      dataIndex: "progressCount",
      width: '600px',
      sorter: (a, b) => a.progressCount - b.progressCount,
      render: this.renderBadgeProgress
    })), /*#__PURE__*/_react.default.createElement(_modal.default, {
      visible: isAwardBadgePopupVisible,
      width: '800px',
      title: "Select a Badge to Award",
      onCancel: this.hideAwardBadgeModal,
      onOk: this.awardBadge
    }, badgeGrid));
  }

}

const mapDispatchToProps = dispatch => {
  return {
    getBadges: () => dispatch(_badges.getBadgeCollectionsAsync.request()),
    awardParticipantBadge: (participantId, badgeCollectionId) => dispatch(_badges.awardParticipantBadgeAsync.request({
      participantId,
      badgeCollectionId
    }))
  };
};

const mapStateToProps = state => {
  const participantId = selectors.getRequestedParticipantId(state);
  const badges = selectors.getBadges(state);
  const badgeCollections = selectors.getBadgeCollections(state);
  const status = selectors.loadBadgesStatus(state);
  const participantBadges = selectors.getRequestedStudyParticipantBadges(state);
  return {
    participantId,
    badges,
    badgeCollections,
    status,
    participantBadges
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BadgesTable);

exports.default = _default;